<template>
  <div>
    <rich-button
      class="item-btn"
      :inline="true"
      @click="handleAdd">
    {{gettext('购买')}}<i class="c-common_icon_back"></i>
    </rich-button>
    <!-- 购买半浮层 -->
    <half-popup 
      :title="payStatus===0?gettext('支付'):''"
      :isShow="isShow" 
      @clickMask="clickMask"
      >
      <div slot="content" v-if="isShow">
        <!-- 购买阶段 -->
        <div v-if="payStatus === 0">
          <!-- 券包信息 -->
          <div class="coupon-mes">
            <p class="coupon-mes-title">{{gettext('券包')}}</p>
            <p class="coupon-mes-price">{{payData.des}}</p>
          </div>
          <!-- 支付方式 -->
          <div class="payment">
            <span class="label">{{gettext('支付方式')}}</span>
            <pay-ways-btn @requestPay="requestPay"/>
          </div>
          <div class="pay-btn">
            <div class="btn-wrap">
              <rich-button
                :disabled="!payDisabled"
                :loading="loading" 
                @click.native="goPay()">
              {{gettext('支付')}}
              </rich-button>
            </div>
          </div>
        </div>
        <!-- 支付中 -->
        <div v-for="(item,index) in PAY_LIST" :key="index">
          <div v-show="payStatus === item.payStatus" class="pay-content">
            <img :src="item.imgUrl"/>
            <p v-if="item.title" class="pay-title">{{item.title}}</p>
            <p v-if="item.text" class="pay-text">{{item.text}}</p>
          </div>
        </div>
      </div>
    </half-popup>
  </div>
</template>

<script>
import HalfPopup from '@/components/half-popup/index'
import payWaysBtn from './payWaysBtn'
import { PAY_LIST } from '../../common/enums'
import { mapGetters, mapActions } from 'vuex'
import { couponPayCk, couponBuyPopupSw, couponPayResultCk, couponPayPopupCk } from '../../track'
export default {
  name: 'buyBtn',
  components: {
    HalfPopup,
    payWaysBtn
  },
  props: {
    payData: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      tid: null,
      queryCount: 0,
      isShow: false,
      btnDisabled: true,
      loading: false,
      autofocus: false,
      isInit: false,
      PAY_LIST: PAY_LIST,
      payStatus: 0 // 支付状态0未支付，1支付中，2支付成功，3支付失败
    }
  },
  computed: {
    ...mapGetters(['globalParams', 'selectedCard']),
    extraInfoList () {
      return this.$store.state.extraInfoList
    },
    newCouponsCenterFrom () {
      return this.$store.state.newCouponsCenterFrom
    },
    payDisabled () {
      return this.isInit && Object.keys(this.selectedCard).length > 0
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.newCouponsCenterFrom === 'payment') this.isShow = true
    }, 1300)
  },
  methods: {
    ...mapActions({
      createOrder: 'createOrder',
      queryOrderStatus: 'queryOrderStatus'
    }),
    //
    requestPay (val) {
      this.isInit = val
    },
    // 兑换弹窗
    handleAdd () {
      if (+this.payData.canPurchase === 1) {
        this.isShow = true
        this.autofocus = true
        // 券包购买卡片弹窗曝光
        couponBuyPopupSw()
      } else {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('券包购买已超限制'),
          type: 'error'
        })
        toast.show()
      }
      // 券包购买卡片“支付”按钮点击
      couponPayCk()
      this.$emit('couponsShow', true)
    },
    clickMask () {
      this.isShow = false
      this.$emit('couponsShow', false)
    },
    async goPay () {
      if (!this.payDisabled) return
      this.$store.commit('UPDATE_NEWCOUPONSCENTERFROM', 'newCouponsCenter')
      try {
        this.loading = true
        this.payStatus = 1
        // 创建订单
        const params = {
          ...this.globalParams,
          productId: this.payData.productId,
          price: this.payData.price,
          payChannel: {
            cardIndex: this.selectedCard.card_index,
            channelId: this.selectedCard.channelID,
            cardOrg: this.selectedCard.card_org
          }
        }
        const res = await this.createOrder(params)
        if (res && res.errno === 0 && res.data) {
          this.polling(async () => {
            this.queryCount <= 5 ? this.getOrderStatus(res) : this.getError(this.gettext('支付超时！'))
          }, 3000)
        } else {
          this.getError(res.errmsg)
        }
      } catch (e) {
        this.getError()
      }
      couponPayPopupCk()
    },
    // 获取订单状态
    async getOrderStatus (res) {
      const orderDetail = await this.queryOrderStatus({
        ...this.globalParams,
        orderId: res.data.orderId
      })
      if (orderDetail && orderDetail.errno === 0 && orderDetail.data) {
        this.queryCount += 1
        // payStatus: 0 => 待支付 1 => 已支付 2 => 已退款
        if (orderDetail.data.payStatus === 1) {
          this.loading = false
          // 支付成功之后处理
          this.payStatus = 2
          this.clearPolling()
          this.handlePay()
          couponPayResultCk({
            from: 1,
            result_status: 1
          })
        }
      } else {
        this.getError(orderDetail.errmsg)
      }
    },

    // 错误情况展示
    getError (val) {
      this.payStatus = 3
      this.clearPolling() // 清除轮询
      this.creatErrorToast(val)
      this.loading = false
      this.handlePay()
      couponPayResultCk({
        from: 1,
        result_status: 0
      })
    },
    // 支付成功或失败后处理
    handlePay () {
      setTimeout(() => {
        this.isShow = false
        this.payStatus = 0
        this.$emit('getProductPay')
      }, 2000)
    },

    polling (fn, internal = 10000) {
      const me = this
      const poll = () => {
        me.tid = window.setInterval(() => {
          fn.call(me)
        }, internal)
      }
      poll()
    },
    clearPolling () {
      window.clearInterval(this.tid)
    },
    creatErrorToast (errmsg = '', defaultMsg = this.gettext('网络繁忙，请稍后再试')) {
      const errorToast = this.$createToast({
        txt: errmsg || defaultMsg,
        time: 9000,
        mask: false,
        type: 'error'
      })
      errorToast.show()
    },
    creatSuccessToast (msg = '', defaultMag = '') {
      const toast = this.$createToast({
        txt: msg || defaultMag,
        time: 9000,
        mask: false,
        type: 'correct'
      })
      toast.show()
    }
  },
  destroyed () {
    this.clearPolling(this.tid) // 清除轮询
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";
  .item-btn{
    padding: 24px 40px;
    min-width: 288px;
    i{
      font-size: 32px;
      transform: rotate(180deg);
      display: inline-block;
      vertical-align: middle;
      margin-left: -10px;
    }
  }
  .pay-btn{
    position: fixed;
    bottom:68px;
    left: 40px;
    width: calc(100vw - 80px);
    font-family: 'Aspira Regular';
    height: 88px;
    border-radius: 8px;
    font-size: 36px;
    color: #FFFFFF;
  }
  .payment{
    display: flex;
    margin: 40px 0 48px;
    .label{
      display: flex;
      font-family: 'Aspira Regular';
      font-size: 32px;
      color: #333333;
      flex: 1;
      text-align: left;
      align-items: center;
    }
  }
  .coupon-mes{
    text-align: center;
    padding: 80px 0 86px;
    border-bottom: 1px solid #EAEAEA;
    &-title{
      font-family: 'Aspira Light';
      font-size: 28px;
      color: #999999;
    }
    &-price{
      font-family: 'Aspira Medium';
      font-size: 68px;
      margin-top:30px;
    }
  }
  .pay-content{
    img{
      width: 400px;
      text-align: center;
    }
    .pay-title{
      font-family: 'Aspira Medium';
      font-size: 48px;
      margin: 0 0 25px 0;
    }
    .pay-text{
      font-family: 'Aspira Regular';
      font-size: 28px;
    }
  }
</style>